<button class="btn btn-undecorated h-100 half-image-container " 
        (click)="selectHalf()" 
        [ngClass]="{ 'action-border-color': half?.name === selectedHalf?.name , 'no-padding-top' : theme.showHalfAndHalfImages}">
  <div class="img-container"  *ngIf="theme.showHalfAndHalfImages">
    <img
      class="img-fluid full-width"
      ftsPicture
      #pictureRef="pictureRef"
      [imgSrc]="!!picture ? picture.src : ('assets/img/card-placeholder.svg' | deployUrl)"
      [alt]="'route.menu.menu_tab.card_menu_item.card_menu_item_image.image_alt' | translate: { itemLabel: half.name }"
    />
    <fts-ghost-element
      *ngIf="!!picture && !pictureRef.isLoaded"
      [height]="(viewPort$ | async).isMobile ? 120 : 150 " 
    ></fts-ghost-element>
  </div>
   <div class="title primary-text-color">{{ half?.name }}</div>
   <span [@expanded]="showSpecialtyHalfDetails" class="description primary-text-color" *ngIf="showSpecialtyHalfDetails">{{ half.description }}</span>
</button>